import { render, staticRenderFns } from "./ProductsTab.vue?vue&type=template&id=b112cbac"
import script from "./ProductsTab.vue?vue&type=script&lang=js"
export * from "./ProductsTab.vue?vue&type=script&lang=js"
import style0 from "./ProductsTab.vue?vue&type=style&index=0&id=b112cbac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports